import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {ParamsModelTable} from '../models/Table'
import {PakingListeThermoboardModel, ThermoBoardNalozi} from '../models/ThermoBoardNalozi'
import {ThermoBoardPaketiModel} from '../models/ThermoBoardPaketi'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/thermoboard/nalozi`
const FMK_NALOZI_API = `${API_URL}/thermoboard/fmk-nalozi`
const KREIRAJ_TB_PAKETE_API = `${API_URL}/thermoboard/kreiraj-tb-pakete`
const ARHIVIRAJ_ISPORUCENE_NALOGE_API = `${API_URL}/thermoboard/arhiviraj-isporucene-naloge`
const ISPORUCENI_OTPREMLJENI_TB_PAKETI_API = `${API_URL}/thermoboard/isporuceni-otprmljeni-tb-paketi`
const OTPREMI_TB_PAKETE_API = `${API_URL}/thermoboard/otpremi-tb-pakete`
const OBRADA_SMJENE_STATUS_API = `${API_URL}/thermoboard/obrada-smjene-status`
const OBRADA_SMJENE_API = `${API_URL}/thermoboard/obrada-smjene`
const SMJENA_PROIZVELA_PAKETE_API = `${API_URL}/thermoboard/smjena-proizvela-pakete`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

export async function getAllNalozi(params: ParamsModelTable) {
  return await axios.get<Array<ThermoBoardNalozi>>(API, {headers: headers, params: params})
}

export async function saveTBNalog(Data: any) {
  try {
    const response = await axios.post(API, Data, {headers: headers})
    if (response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function saveThermoBoardFmkNalog(data: any) {
  try {
    const response = await axios.post(FMK_NALOZI_API, data, {headers: headers})
    return response.data
  } catch (error: any) {
    console.error('Error saving Thermoboard FMK nalog:', error)
    return error.response?.data
  }
}

export async function fetchThermoBoardFmkNalog(id: number) {
  try {
    const response = await axios.get(`${FMK_NALOZI_API}/${id}`, {headers: headers})
    return response.data?.data ?? response.data
  } catch (error: any) {
    console.error('Error fetching Thermoboard FMK nalog:', error)
    return error.response?.data
  }
}

export async function updateThermoBoardFmkNalog(data: any, id: number) {
  try {
    const response = await axios.post(`${FMK_NALOZI_API}/${id}?_method=PATCH`, data, {
      headers: headers,
    })
    return response.data
  } catch (error: any) {
    console.error('Error updating Thermoboard FMK nalog:', error)
    return error.response?.data
  }
}

export async function getAllThermoBoardFmkNalozi(params: ParamsModelTable) {
  return await axios.get(FMK_NALOZI_API, {
    headers: headers,
    params: params,
  })
}

export async function kreirajThermoBoardPakete(data: any) {
  try {
    const response = await axios.post(KREIRAJ_TB_PAKETE_API, data, {headers: headers})
    return response.data
  } catch (error: any) {
    console.error('Error creating Thermoboard paketi:', error)
    return error.response?.data
  }
}

export async function deleteThermoBoardFmkNalog(Id: number) {
  try {
    const response = await axios.delete(`${FMK_NALOZI_API}/${Id}`, {headers: headers})
    return response.data
  } catch (error: any) {
    console.error('Error deleting data:', error)
    return error.response.data // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function fetchTBNalog(Id: number): Promise<Partial<ThermoBoardNalozi>> {
  try {
    const response = await axios.get(`${API}/${Id}`)
    return response.data.data
  } catch (error: any) {
    console.error('Error fetching data:', error)
    return error.response.data // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function updateTBNalog(Data: any, id: number) {
  try {
    const response = await axios.post(`${API}/${id}?_method=PATCH`, Data, {headers: headers})
    return response.data
  } catch (error: any) {
    console.error('Error fetching data:', error)
    return error.response.data // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function deleteTBNalog(Id: number) {
  try {
    const response = await axios.delete(`${API}/${Id}`, {headers: headers})
    return response.data
  } catch (error: any) {
    console.error('Error deleting data:', error)
    return error.response.data // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function getAllPaketiThermoboard(params: any) {
  return await axios.get<Array<ThermoBoardPaketiModel>>(`${API_URL}/thermoboard/getAllPaketi`, {
    headers: headers,
    params: params,
  })
}

export async function getPakingListeThermoboard(params: any) {
  return await axios.get<Array<PakingListeThermoboardModel>>(
    `${API_URL}/thermoboard/getPakingListe`,
    {
      headers: headers,
      params: params,
    }
  )
}

export async function getIzvjestajPoTipuThermoboard(params: any) {
  return await axios.get(`${API_URL}/thermoboard/izvjestajPoTipu`, {
    headers: headers,
    params: params,
  })
}

export async function arhivirajIsporuceneNaloge() {
  try {
    const response = await axios.put(ARHIVIRAJ_ISPORUCENE_NALOGE_API, null, {
      headers: headers,
    })
    return response.data
  } catch (error: any) {
    console.error('Error archiving delivered Thermoboard nalozi:', error)
    return error.response?.data
  }
}

export async function getIsporuceniOtpremljeniTbPaketi(params: {datum: string}) {
  return await axios.get(ISPORUCENI_OTPREMLJENI_TB_PAKETI_API, {
    headers: headers,
    params: params,
  })
}

export async function otpremiTbPakete(data: {stavkaIds: number[]}) {
  try {
    const response = await axios.post(OTPREMI_TB_PAKETE_API, data, {headers: headers})
    return response.data
  } catch (error: any) {
    console.error('Error shipping Thermoboard paketi:', error)
    return error.response?.data
  }
}

export type ObradaSmjeneStatus = {
  mozePokrenutiSmjenu: boolean
  trebaZatvoritiSmjenu: boolean
  jeVodjaSmjene: boolean
  jeUposlenikSmjene: boolean
  aktivnaSmjena: any
}

export async function getObradaSmjeneStatus() {
  const response = await axios.get(OBRADA_SMJENE_STATUS_API, {headers: headers})
  return response.data?.data ?? response.data
}

export async function getObradaSmjene(params: {page: number; per_page: number}) {
  return await axios.get(OBRADA_SMJENE_API, {
    headers: headers,
    params: params,
  })
}

export async function fetchObradaSmjene(id: number) {
  const response = await axios.get(`${OBRADA_SMJENE_API}/${id}`, {headers: headers})
  return response.data?.data ?? response.data
}

export async function updateObradaSmjene(id: number, data: any) {
  const response = await axios.post(`${OBRADA_SMJENE_API}/${id}?_method=PATCH`, data, {
    headers: headers,
  })
  return response.data
}

export async function deleteObradaSmjene(id: number) {
  const response = await axios.delete(`${OBRADA_SMJENE_API}/${id}`, {headers: headers})
  return response.data
}

export async function getSmjenaProizvelaPakete(smjenaId: number) {
  return await axios.get(SMJENA_PROIZVELA_PAKETE_API, {
    headers: headers,
    params: {smjenaId},
  })
}

export async function pokreniObradaSmjene(data: {uposlenici: number[]}) {
  try {
    const response = await axios.post(OBRADA_SMJENE_API, data, {headers: headers})
    return response.data
  } catch (error: any) {
    console.error('Error starting Thermoboard shift:', error)
    return error.response?.data
  }
}

export async function zatvoriObradaSmjene(data: {
  id: number
  pauza_minuta: number | null
  pauza_kvar: number | null
}) {
  try {
    const {id, ...payload} = data
    const response = await axios.post(`${OBRADA_SMJENE_API}/${id}?_method=PATCH`, payload, {
      headers: headers,
    })
    return response.data
  } catch (error: any) {
    console.error('Error closing Thermoboard shift:', error)
    return error.response?.data
  }
}
